import {
  Component,
  OnInit,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import { State as StpState } from '@app/stp/state/reducers';
import { DashboardState } from '@app/features/dashboard/state/reducers/dashboard.reducer';

import {
  selectJourneyPath,
  selectNavigationDetails,
  selectPanelConfig,
  selectPolicyId,
  selectProgressbarDisplayStatus,
  selectPolicyChangeDate,
  getVehicleDetails,
  selectVerifyPolicyDetails,
} from '@app/stp/state/selectors';
import { selectPolicyChangeType } from '@app/features/dashboard/state/selectors';

import { ButtonState } from '@global/infrastructure/interfaces/button-state';
import { PanelState } from '@global/infrastructure/interfaces/panel-state';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-stp-container',
  templateUrl: './stp-container.component.html',
})
export class StpContainerComponent implements OnInit, AfterViewChecked {
  navigationDetails$: Observable<ButtonState[]>;
  panelConfig$: Observable<PanelState>;
  isShowProgressBar$: Observable<boolean>;
  policyId$: Observable<string>;
  policyChangeSelection$: Observable<any>;
  policyChangeDate$: Observable<Date>;
  journeyPath$: Observable<any>;
  vehicle$: Observable<{ make: string; reg: string }>;
  selectedPolicyChange$: Observable<string>;

  constructor(
    private stpStore: Store<StpState>,
    protected dashboardStore: Store<DashboardState>,
    private cd: ChangeDetectorRef,
    private title: Title
  ) {}

  ngOnInit() {
    this.navigationDetails$ = this.stpStore.pipe(
      select(selectNavigationDetails)
    );

    this.panelConfig$ = this.stpStore.pipe(
      select(selectPanelConfig),
      tap((config) => {
        if (config?.pageTitle) {
          this.title.setTitle(config.pageTitle);
        }
      })
    );
    this.policyId$ = this.stpStore.pipe(select(selectPolicyId));
    this.policyChangeDate$ = this.stpStore.pipe(select(selectPolicyChangeDate));
    this.journeyPath$ = this.stpStore.pipe(select(selectJourneyPath));

    this.isShowProgressBar$ = this.stpStore.pipe(
      select(selectProgressbarDisplayStatus)
    );
    this.vehicle$ = this.stpStore.pipe(select(getVehicleDetails));
    this.vehicle$ = this.stpStore.pipe(select(selectVerifyPolicyDetails));
    this.selectedPolicyChange$ = this.dashboardStore.pipe(
      select(selectPolicyChangeType)
    );
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }
}
